import { CommonModule, DOCUMENT } from '@angular/common'
import { Component, Inject, inject } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { RecursiveDestinationsComponent } from "./recursive-destinations/recursive-destinations.component";
import { SkeletonComponent } from '@shared/components/skeleton/skeleton.component'
import { cdnUrl } from '../../app.module'
import { InternationalHotelsService } from './international-hotels.service'


@Component({
  selector: 'iho-international-hotels',
  templateUrl: './international-hotels.component.html',
  styleUrls: ['./international-hotels.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    RecursiveDestinationsComponent,
    SkeletonComponent
]
})

export class internationalHotelsComponent  {
  repo = inject(InternationalHotelsService);
  cdnUrl = cdnUrl;

  showIcon: boolean[] = [];
  loading = true

  constructor(  
       @Inject(DOCUMENT) private document: Document,
      ) {
  }


  showMore(index:number,ev:Event) {
    (this.document as any).querySelector(`.showMore-${index}`).previousElementSibling.classList.toggle('max-h-72');
    this.showIcon[index] = !this.showIcon[index];
  }


}
